import { render, staticRenderFns } from "./BusinessDocumentNegotiation.vue?vue&type=template&id=2fafa631&"
import script from "./BusinessDocumentNegotiation.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentNegotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fafa631')) {
      api.createRecord('2fafa631', component.options)
    } else {
      api.reload('2fafa631', component.options)
    }
    module.hot.accept("./BusinessDocumentNegotiation.vue?vue&type=template&id=2fafa631&", function () {
      api.rerender('2fafa631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/negotiationPages/BusinessDocumentNegotiation.vue"
export default component.exports